<template>
  <div class="tab-navigation">
    <div class="tab-navigation__wrapper">
      <div v-for="item of list" @click="() => $emit('change', item.id)" class="tab-navigation__item" :class="active === item.id && 'active'">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['list', 'active']
  }
</script>

<style scoped lang="scss">
  @import '@/assets/scss/style.scss';
  .tab-navigation {
    &.fixed-width {
      .tab-navigation__item {
        width: 122px;
      }
    }
    &__wrapper {
      display: flex;
      justify-content: flex-start;
      padding: 17px 0;
      border-bottom: 1px solid #d6d9de;
    }
    &__item {
      font-size: 16px;
      color: #737b8f;
      margin-right: 48px;
      font-weight: 500;
      position: relative;
      text-align: center;
      white-space: nowrap;
      cursor: pointer;
      &:before {
        content: "";
        position: absolute;
        border-bottom: 3px solid transparent;
        left: 0;
        right: 0;
        bottom: -19px;
        transition: .3s;
      }
      &:last-child {
        margin-right: none;
      }
      &.active {
        color: $dark-blue;
        font-weight: 700;
        &:before {
          border-color: $dark-blue;
        }
      }
    }
  }
</style>
